module.exports = __webpack_public_path__ + "static/img/o9m4.3b47e70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/o9m/o9m4.jpg
// module id = A8kB
// module chunks = 1